import { reactive } from 'vue'
import emitter from '../utils/emitter'

const state = reactive({
  open: false,
  title: '',
  message: '',
  type: 'info',
  timeout: 4000,
  persistent: false,
  html: false,
  id: null,
  icon: null,
})

let hideTimer = null
let armed = false
let ready = false
let queued = null
const ARM_DELAY = 1400

function isStickyId(id) {
  const value = String(id || '')
  return value.startsWith('premium-drop-') || value.startsWith('wheelspin-')
}

function isPremiumId(id) {
  return String(id || '').startsWith('premium-drop-')
}

function clearHideTimer() {
  if (hideTimer) {
    window.clearTimeout(hideTimer)
    hideTimer = null
  }
}

function apply(payload) {
  state.title = payload.title || ''
  state.message = payload.message || ''
  state.type = payload.type || 'info'
  state.persistent = !!payload.persistent
  state.timeout = payload.persistent ? -1 : payload.timeout ?? 4000
  state.html = !!payload.html
  state.id = payload.id ?? null
  state.icon = payload.icon || null
}

function scheduleHide() {
  clearHideTimer()
  if (!state.persistent && state.timeout > 0) {
    hideTimer = window.setTimeout(() => { state.open = false }, state.timeout)
  }
}

export function dismissNotify() {
  clearHideTimer()
  state.open = false
}

export function armNotify() {
  if (armed) return
  armed = true
  window.setTimeout(() => {
    ready = true
    const pending = queued
    queued = null
    if (pending) {
      apply(pending)
      state.open = true
      scheduleHide()
    }
  }, ARM_DELAY)
}

export function notify(payload) {
  const next = typeof payload === 'string' ? { message: payload } : payload || {}
  const incomingSticky = isStickyId(next.id)
  armNotify()
  if (!ready) {
    const queuedSticky = isStickyId(queued?.id)
    const queuedPremium = isPremiumId(queued?.id)
    const incomingPremium = isPremiumId(next.id)
    if ((queuedPremium && !incomingPremium) || (queuedSticky && !incomingSticky)) return
    queued = next
    return
  }
  clearHideTimer()
  if (state.open) {
    if (state.id != null && state.id === (next.id ?? null)) {
      if (state.message === (next.message || '') && state.title === (next.title || '')) return
      apply(next)
      scheduleHide()
      return
    }
    if ((isStickyId(state.id) && !incomingSticky) || (isPremiumId(state.id) && !isPremiumId(next.id))) return
    apply(next)
    scheduleHide()
    return
  }
  apply(next)
  state.open = true
  scheduleHide()
}

export function useNotify() {
  return { state, notify, dismissNotify, armNotify }
}

emitter.on('shell-notify', notify)
